// Copyright (c) 2017 Comsearch, Inc., All rights reserved

export const makeCsvContent = data => (
  data.reduce((a, d, i) => {
    // conditional ensures that commas within strings will be escaped properly
    // "NOT MAPPPED" allows us to see when a value is not properly mapped for export.
    const f = d.map((v = 'NOT MAPPED') => v !== null && ~v.toString().indexOf(',') ? `"${v}"` : v)
    return `${a}${f.join(`,`)}\n`
  }, '')
)

const createCSV = (title, data) => {
  // Adding UTF-8 BOM to Blob makes sure that special characters are displayed properly in csv file.
  // https://newbedev.com/generate-csv-for-excel-via-javascript-with-unicode-characters
  const blob = new Blob(['\ufeff', makeCsvContent(data)], { type: 'text/csv' })
  const fileName = `${title}.csv`

  // for IE
  if (navigator.msSaveBlob) {
    return navigator.msSaveBlob(blob, fileName)
  }

  // to create a file and give it a specific name, create an <a> DOM node
  // with the download attribute set to the encodedURi (the to be CSV file)
  // append to the DOM and click. all of this is necessary to achieve this
  // functionality cross browser
  const encodedUri = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.setAttribute('href', encodedUri)
  link.setAttribute('download', fileName)
  document.body.appendChild(link) // Required for FF
  link.click()
  document.body.removeChild(link)
}

export default createCSV
